
import Button from '../../../components/base/Button';
import Badge from '../../../components/base/Badge';

export default function ResultsSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cases" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            成果を"数字"で示す
          </h2>
          <p className="text-xl text-gray-600">実績ハイライト</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {/* K鉄工所様 */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/dbce3aa2b77cb52dc1786d8b8df4903f.png"
                alt="K鉄工所様"
                className="w-full h-32 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              K鉄工所様（北陸地方）× venturion
            </h3>
            <div className="flex flex-wrap gap-2 mb-4">
              <Badge variant="yellow" size="sm">70%削減</Badge>
              <Badge variant="black" size="sm">+40-60h</Badge>
            </div>
            <ul className="text-gray-600 space-y-2 mb-6">
              <li>• 段取り70%削減／一発加工化／不良ゼロ</li>
              <li>• プリセッタ1台導入により、+40〜60h/月の作業時間創出</li>
              <li>• 投資回収：約5か月</li>
            </ul>
          </div>
          
          {/* 五和工業様 */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/72f5e29f0963a9924bdaa62608806171.jfif"
                alt="五和工業様"
                className="w-full h-32 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              五和工業様（広島）× venturion
            </h3>
            <div className="flex flex-wrap gap-2 mb-4">
              <Badge variant="yellow" size="sm">6h→30min</Badge>
              <Badge variant="black" size="sm">+15pt</Badge>
            </div>
            <ul className="text-gray-600 space-y-2 mb-6">
              <li>• 最長段取りワーク：6h → 30min（▲92%）</li>
              <li>• ボーリングバー段取り誰でも5分／H7穴一発</li>
              <li>• 明白な製品の品質向上につながった</li>
              <li>• 不良ゼロと段取り時間短縮により、納期短縮を実現・・・受注増</li>
              <li>• 機械稼働率+15pt／回収：約8か月</li>
            </ul>
          </div>
          
          {/* ファイブ・ストレート様 */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/4634784f84fe46f4c7c010eb73bb271e.jfif"
                alt="ファイブ・ストレート様"
                className="w-full h-32 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              ファイブ・ストレート様（兵庫）× smile
            </h3>
            <div className="flex flex-wrap gap-2 mb-4">
              <Badge variant="yellow" size="sm">試し削りゼロ</Badge>
              <Badge variant="black" size="sm">1.5-2倍</Badge>
            </div>
            <ul className="text-gray-600 space-y-2 mb-6">
              <li>• 試し削りほぼゼロ／多刃リーマ段取り1/2</li>
              <li>• チップ寿命1.5〜2倍／回収：1年以内</li>
              <li>• 不良が完全にゼロに</li>
            </ul>
          </div>
        </div>
        
        <div className="bg-yellow-400 p-8 rounded-xl text-center mb-8">
          <h3 className="text-2xl font-bold text-black mb-4">
            月あたり60～100時間程度の空き枠が生まれ、材料・工具ロスが激減
          </h3>
          <p className="text-lg text-black font-semibold">
            ＝売上拡張×原価低減の同時達成
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button variant="primary" size="lg" onClick={scrollToContact}>
            <i className="ri-calculator-line mr-2"></i>
            自社ラインでROIを試算する
          </Button>
          <Button variant="outline" size="lg" onClick={scrollToContact}>
            <i className="ri-file-download-line mr-2"></i>
            事例PDFを受け取る
          </Button>
        </div>
      </div>
    </section>
  );
}
